import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setMicroscopyReviewCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getMicroscopyReviewCount() {
            return HTTP.get('/kenya/microscopy_qc/get_count');
        }
    },
}